
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from "next/head"

import SEO from "@/meta/SEO"
import Default from "@/templates/Default"
import AboutPage from "@/views/about/AboutPage"

function About() {
  return (
    <>
      <Head>
        <title>O Nas | fansi.pl</title>
        <SEO description="fansi to platforma, na której możesz kupić produkty od najlepszych Twórców: e-booki, audiobooki, planery, książki, kosmetyki, personalizowane video, kolekcje ubrań i gadżety. fansi to wsparcie dla influencerów w tworzeniu i sprzedaży autorskich produktów, platforma monetyzowania popularności." />
      </Head>
      <AboutPage />
    </>
  )
}
About.Layout = Default

export default About


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/about',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  